/* Nova Milano: WhatsApp bubble, cart note, gift, header, mobile menu, sticky bar, variant buttons, quick add, cart ETA */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);

  /* WhatsApp bubble: show once per session after a delay */
  const wa = $('[data-wa]');
  const bubble = wa && $('[data-wa-bubble]', wa);
  if (bubble) {
    let seen = false;
    try { seen = sessionStorage.getItem('nm-wa') === '1'; } catch (_) {}
    if (!seen) setTimeout(() => { bubble.hidden = false; }, 9000);
    wa.addEventListener('click', (e) => {
      if (e.target.closest('[data-wa-dismiss]') || e.target.closest('.wa-float__btn')) {
        bubble.hidden = true;
        try { sessionStorage.setItem('nm-wa', '1'); } catch (_) {}
      }
    });
  }

  /* Cart note autosave */
  let t;
  document.addEventListener('input', (e) => {
    const el = e.target.closest('[data-cart-note]');
    if (!el) return;
    clearTimeout(t);
    t = setTimeout(() => {
      fetch(((window.NM && NM.routes && NM.routes.root) || '/').replace(/\/$/, '') + '/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: el.value })
      }).catch(() => {});
    }, 500);
  });

  /* Gift option -> cart attributes */
  const root = ((window.NM && NM.routes && NM.routes.root) || '/').replace(/\/$/, '');
  const saveAttrs = (attrs) => fetch(root + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(() => {});
  const syncGift = (box, attrs) => {
    document.querySelectorAll('[data-gift]').forEach((g) => {
      if (g === box) return;
      Object.keys(attrs).forEach((k) => {
        const el = g.querySelector('[data-gift-attr="' + k + '"]');
        if (!el) return;
        if (el.type === 'checkbox') el.checked = attrs[k] === 'Da'; else el.value = attrs[k];
      });
    });
  };
  let gt;
  document.addEventListener('change', (e) => {
    const tog = e.target.closest('[data-gift-toggle]');
    if (tog) {
      const on = tog.checked;
      document.querySelectorAll('[data-gift]').forEach((g) => {
        g.classList.toggle('is-on', on);
        const tg = g.querySelector('[data-gift-toggle]'); if (tg) tg.checked = on;
        const f = g.querySelector('[data-gift-fields]'); if (f) f.hidden = !on;
      });
      const attrs = { 'Poklon': on ? 'Da' : '' };
      if (!on) { attrs['Poklon primatelj'] = ''; attrs['Poruka za čestitku'] = ''; attrs['Bez računa u paketu'] = ''; }
      else { const f = tog.closest('[data-gift]').querySelector('[data-gift-fields] input, [data-gift-fields] textarea'); if (f) setTimeout(() => f.focus(), 50); }
      saveAttrs(attrs);
      return;
    }
    const chk = e.target.closest('input[type="checkbox"][data-gift-attr]');
    if (chk) { const a = {}; a[chk.dataset.giftAttr] = chk.checked ? 'Da' : ''; saveAttrs(a); syncGift(chk.closest('[data-gift]'), a); }
  });
  document.addEventListener('input', (e) => {
    const el = e.target.closest('input[type="text"][data-gift-attr], textarea[data-gift-attr]');
    if (!el) return;
    const box = el.closest('[data-gift]');
    const c = box && box.querySelector('[data-gift-count]');
    if (c && el.tagName === 'TEXTAREA') c.textContent = el.value.length + '/250';
    clearTimeout(gt);
    gt = setTimeout(() => { const a = {}; a[el.dataset.giftAttr] = el.value.trim(); saveAttrs(a); syncGift(box, a); }, 450);
  });

  /* Header: measure, transparent over hero on homepage, solid after scrolling; hero parallax */
  const hdr = document.querySelector('.section-header');
  const ann = document.querySelector('[data-announce]');
  const isHome = document.body.classList.contains('template-index');
  const measure = () => {
    const rs = document.documentElement.style;
    const head = hdr && hdr.querySelector('.header');
    if (head) {
      head.classList.remove('hdr--stacked');
      const last = head.querySelector('.header__nav .nav > li:last-child');
      const logo = head.querySelector('.header__logo');
      if (window.innerWidth >= 1200 && last && logo && last.getBoundingClientRect().right > logo.getBoundingClientRect().left - 28) head.classList.add('hdr--stacked');
    }
    if (hdr) rs.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    rs.setProperty('--ann-h', (ann ? ann.offsetHeight : 0) + 'px');
  };
  measure();
  window.addEventListener('resize', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  window.addEventListener('load', measure);
  if (hdr && isHome) {
    const hero = document.querySelector('.slideshow');
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const upd = () => {
      const bar = document.querySelector('[data-search-bar]');
      const nav = document.querySelector('[data-mobile-nav]');
      const annH = ann ? ann.offsetHeight : 0;
      const solid = window.scrollY > annH + 10 || (bar && !bar.hidden) || (nav && !nav.hidden);
      hdr.classList.toggle('is-solid', !!solid);
      if (hero && !calm) {
        const h = hero.offsetHeight, y = window.scrollY;
        if (y < h + annH) hero.style.setProperty('--plx', Math.round(y * 0.35) + 'px');
      }
    };
    let ticking = false;
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { upd(); ticking = false; }); } }, { passive: true });
    document.addEventListener('click', () => setTimeout(upd, 40));
    upd();
  }

  /* Mobile menu: move to <body> (so header animations/stacking can't squash it) + real scroll lock */
  const mnav = document.querySelector('[data-mobile-nav]');
  if (mnav) {
    if (mnav.parentElement !== document.body) document.body.appendChild(mnav);
    let savedY = 0, locked = false;
    const lock = () => {
      if (locked) return; locked = true; savedY = window.scrollY;
      document.body.style.top = -savedY + 'px'; document.body.classList.add('nav-locked');
    };
    const unlock = () => {
      if (!locked) return; locked = false;
      document.body.classList.remove('nav-locked'); document.body.style.top = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedY);
    };
    new MutationObserver(() => { mnav.hidden ? unlock() : lock(); }).observe(mnav, { attributes: true, attributeFilter: ['hidden'] });
    mnav.addEventListener('click', (e) => { const a = e.target.closest('a[href]'); if (a && a.target !== '_blank') unlock(); });
  }

  /* Product page: sticky bar image + colour picker, synced with the main selector */
  document.querySelectorAll('[data-pp-sticky]').forEach((bar) => {
    const sec = bar.closest('[data-pdp]') || document;
    const img = bar.querySelector('[data-pp-sticky-img]');
    const label = bar.querySelector('[data-pp-sticky-color]');
    const mainInput = (idx, val) => Array.from(sec.querySelectorAll('input[data-pp-option="' + idx + '"]')).find((i) => i.value === val);
    const sync = () => {
      bar.querySelectorAll('[data-pp-sticky-opt]').forEach((b) => {
        const inp = mainInput(b.dataset.ppStickyOpt, b.dataset.value);
        const on = !!(inp && inp.checked);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', String(on));
        const sw = inp && inp.closest('.pp-swatch');
        b.classList.toggle('is-unavailable', !!(sw && sw.classList.contains('is-unavailable')));
        if (on) {
          if (img && b.dataset.img && img.getAttribute('src') !== b.dataset.img) img.src = b.dataset.img;
          if (label) label.textContent = b.dataset.value;
        }
      });
    };
    bar.addEventListener('click', (e) => {
      const b = e.target.closest('[data-pp-sticky-opt]');
      if (!b) return;
      const inp = mainInput(b.dataset.ppStickyOpt, b.dataset.value);
      if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      sync();
    });
    sec.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('input[data-pp-option]')) setTimeout(sync, 0); });
    sync();
  });

  /* Product page: buttons take the colour of the selected variant */
  (function () {
    const pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;
    const INK = '#2B1D1A';
    const MAP = [
      ['rose gold', 'linear-gradient(135deg,#f3cdbf,#c98e7a)', INK, '#b97a66'],
      ['khaki gold', 'linear-gradient(135deg,#cfc08f,#8c7c47)', INK, '#7d6e3d'],
      ['biege gold', 'linear-gradient(135deg,#efdfc2,#c4a46a)', INK, '#a88a52'],
      ['beige gold', 'linear-gradient(135deg,#efdfc2,#c4a46a)', INK, '#a88a52'],
      ['bež zlatna', 'linear-gradient(135deg,#efdfc2,#c4a46a)', INK, '#a88a52'],
      ['roza zlatna', 'linear-gradient(135deg,#f3cdbf,#c98e7a)', INK, '#b97a66'],
      ['khaki zlatna', 'linear-gradient(135deg,#cfc08f,#8c7c47)', INK, '#7d6e3d'],
      ['navy blue', '#1f2e4d', '#fff', '#1f2e4d'], ['dark blue', '#1f2e4d', '#fff', '#1f2e4d'], ['tamnoplava', '#1f2e4d', '#fff', '#1f2e4d'],
      ['multicolor', 'linear-gradient(100deg,#c9584c,#e4b45a,#6f8a5a,#2c4a7c)', '#fff', '#6b2337'],
      ['rainbow', 'linear-gradient(100deg,#c9584c,#e4b45a,#6f8a5a,#2c4a7c)', '#fff', '#6b2337'],
      ['šarena', 'linear-gradient(100deg,#c9584c,#e4b45a,#6f8a5a,#2c4a7c)', '#fff', '#6b2337'],
      ['champapage', 'linear-gradient(135deg,#f4e7cf,#d4b98c)', INK, '#a88a52'],
      ['champagne', 'linear-gradient(135deg,#f4e7cf,#d4b98c)', INK, '#a88a52'],
      ['silver', 'linear-gradient(135deg,#f3f3f3,#a7a7a7)', INK, '#7c7c7c'], ['srebrna', 'linear-gradient(135deg,#f3f3f3,#a7a7a7)', INK, '#7c7c7c'],
      ['gold', 'linear-gradient(135deg,#ecd697,#b48a3c)', INK, '#9a7430'], ['zlatna', 'linear-gradient(135deg,#ecd697,#b48a3c)', INK, '#9a7430'],
      ['black', '#1c1a19', '#fff', '#1c1a19'], ['crna', '#1c1a19', '#fff', '#1c1a19'],
      ['coccio', '#a4553a', '#fff', '#a4553a'], ['clay', '#b8735a', '#fff', '#b8735a'],
      ['apricot', '#f2b98f', INK, '#c9845a'],
      ['khaki', '#8a8259', '#fff', '#8a8259'],
      ['beige', '#dcc7aa', INK, '#a88f6c'], ['biege', '#dcc7aa', INK, '#a88f6c'], ['bež', '#dcc7aa', INK, '#a88f6c'],
      ['nude', '#e6c9b3', INK, '#b08a70'],
      ['gray', '#8f8d8a', '#fff', '#8f8d8a'], ['grey', '#8f8d8a', '#fff', '#8f8d8a'], ['siva', '#8f8d8a', '#fff', '#8f8d8a'],
      ['pink', '#e9b8c0', INK, '#c27c8a'], ['roza', '#e9b8c0', INK, '#c27c8a'],
      ['blue', '#2c4a7c', '#fff', '#2c4a7c'], ['plava', '#2c4a7c', '#fff', '#2c4a7c'],
      ['red', '#a3262f', '#fff', '#a3262f'], ['crvena', '#a3262f', '#fff', '#a3262f'],
      ['brown', '#6b4a34', '#fff', '#6b4a34'], ['smeđa', '#6b4a34', '#fff', '#6b4a34'],
      ['white', '#ffffff', INK, '#b9aaa4'], ['bijela', '#ffffff', INK, '#b9aaa4']
    ];
    const find = (name) => { const n = String(name || '').toLowerCase().trim(); const hit = MAP.find(([k]) => n === k) || MAP.find(([k]) => n.includes(k)); return hit || null; };
    const apply = () => {
      const sel = pdp.querySelector('.pp-swatch--color input:checked');
      const hit = sel && find(sel.value);
      pdp.classList.toggle('has-vcolor', !!hit);
      if (!hit) return;
      pdp.style.setProperty('--vbtn-bg', hit[1]);
      pdp.style.setProperty('--vbtn-fg', hit[2]);
      pdp.style.setProperty('--vbtn-tone', hit[3]);
      pdp.style.setProperty('--vbtn-shadow', hit[2] === '#fff' ? '0 1px 2px rgba(0,0,0,.35)' : 'none');
    };
    pdp.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('input[data-pp-option]')) setTimeout(apply, 0); });
    apply();
  })();

  /* Product cards: quick add with colour picker */
  (function () {
    const closeAll = (except) => document.querySelectorAll('[data-quick-panel]:not([hidden])').forEach((pnl) => {
      if (pnl === except) return;
      pnl.hidden = true;
      const b = pnl.parentElement.querySelector('[data-quick-pick]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-quick-pick]');
      if (pick) {
        e.preventDefault();
        const pnl = pick.parentElement.querySelector('[data-quick-panel]');
        if (!pnl) return;
        const open = pnl.hidden;
        closeAll(pnl);
        pnl.hidden = !open;
        pick.setAttribute('aria-expanded', String(open));
        if (open) { const f = pnl.querySelector('.qp:not(:disabled)'); if (f) f.focus({ preventScroll: true }); }
        return;
      }
      if (e.target.closest('[data-quick-close]')) { closeAll(); return; }
      const chip = e.target.closest('.qp[data-quick-add]');
      if (chip) { setTimeout(() => closeAll(), 350); return; }
      if (!e.target.closest('[data-quick-panel]')) closeAll();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  })();

  /* Product page delivery line: make sure no long dashes slip through */
  document.querySelectorAll('.pp-perk div').forEach((el) => { el.innerHTML = el.innerHTML.replace(' – stiže', '. Stiže'); });

  /* Delivery ETA in cart trust row */
  function eta() {
    const ex = (window.NM && NM.extras) || {};
    const add = (d, n) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6 !== 0) n--; } return x; };
    const now = new Date();
    let start = now;
    if (now.getHours() >= (ex.cutoff || 14) || now.getDay() % 6 === 0) start = add(now, 1);
    const a = add(start, ex.min || 2), b = add(start, ex.max || 5);
    const f = (d) => d.toLocaleDateString('hr-HR', { day: 'numeric', month: 'numeric' });
    const txt = 'Stiže ' + f(a) + ' do ' + f(b);
    document.querySelectorAll('[data-cart-eta]').forEach((el) => { if (el.textContent !== txt) el.textContent = txt; });
  }
  eta();
  new MutationObserver(eta).observe(document.body, { childList: true, subtree: true });
})();
